export default __webpack_public_path__ + "static/media/letalk-small-logo-purple.93c8e9ea.svg";